import { gql } from "@apollo/client";

export const OCR_UPLOAD_MUTATION = gql`
  mutation ocrUpload($file: Upload!) {
    ocrUpload(file: $file) {
      commandId
      correlationId
    }
  }
`;
